import { OptionData, Options } from "select2";
import { FilterGroup } from "../DesignersFilters";
import { FiltersController } from "../Tools/FiltersController";
import { globalTemplateResult, globalMatcher, checkAndDestroySelect2 } from "../Tools/GlobalMethods";
import { IFilter } from "../Tools/IFilter";

export class SvgFilter implements IFilter {
    id: string;
    name?: string | null;
    type: string;
    parentGroup: FilterGroup;
    controller: FiltersController;

    constructor(parentGroup: FilterGroup) {
        this.id = 'svg';
        this.name = 'Forme';
        this.type = "svg";
        this.parentGroup = parentGroup;
        this.controller = new FiltersController();
    }

    html(): string {
        let html = `
        <div class="filter" style="display: flex;flex-direction: column;align-items: center;margin:0 auto;max-width: 380px;width: 100%;">
            <span>${this.name}</span>
            <select id="svgInput" class="dropdown" title="${this.name}" style="width: 100%">
            </select>
        </div>
        `;

        setTimeout(() => {
            FilterGroup.loadSVGs().then(() => {
                if (this.parentGroup.isDestroyed) return;
                checkAndDestroySelect2('svgInput');
                let svgs = FilterGroup.SVGs.map((element) => {
                    return {
                        id: element._id || '-1',
                        text: element.name,
                        title: this.name,
                        selected: FilterGroup.filters.svg && FilterGroup.filters.svg._id === element._id
                    } as OptionData;
                });
                $('#svgInput').select2({
                    width: 'element',
                    placeholder: {
                        id: '-1',
                        text: 'Choisissez une forme',
                    },
                    templateResult: globalTemplateResult,
                    matcher: globalMatcher,
                    data: [
                        {
                            id: '-1',
                            text: 'Choisissez une forme',
                            selected: true,

                        } as OptionData,
                        ...svgs,
                    ],
                    selectionCssClass: 'select-control',
                } as Options);


                $('#svgInput').on('change.select2', () => {
                    let selectedValue = $('#svgInput').val() as string;
                    if (selectedValue === '-1') {
                        FilterGroup.filters.svg = null;
                    } else {
                        FilterGroup.filters.svg = FilterGroup.SVGs.find((element) => selectedValue === element._id) || null;
                    }
                    FilterGroup.updateSVG(FilterGroup.filters.svg)
                });
            });
        }, 50);

        return html;
    }

    destroy(): void {
        $('#svgInput').off('change.select2');
        checkAndDestroySelect2('svgInput');
        this.controller.destroy();
    }
}